export default __webpack_public_path__ + "static/media/footerLogo.44399288.svg";